import { render, staticRenderFns } from "./ViewSettings.vue?vue&type=template&id=710d6246&scoped=true"
import script from "./ViewSettings.vue?vue&type=script&lang=js"
export * from "./ViewSettings.vue?vue&type=script&lang=js"
import style0 from "./ViewSettings.vue?vue&type=style&index=0&id=710d6246&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710d6246",
  null
  
)

export default component.exports